import { BrandKit } from 'types'
import { useUpdateBrandKit } from 'hooks/queries/brandKits/useUpdateBrandKit'
import { useHistory, useLocation } from 'react-router-dom'
import { EditableName, Props as EditableNameProps } from 'components/EditableName/EditableName'

interface Props extends Pick<EditableNameProps, 'trigger' | 'placement'> {
  brandKit: BrandKit
  isDisabled?: boolean
}

export const BrandKitEditableName = ({ brandKit, isDisabled = false, ...props }: Props) => {
  const { name, id } = brandKit

  const { mutate } = useUpdateBrandKit({ id })
  const { pathname, hash, state, search } = useLocation<{ isEditingName: boolean; brandKitId: number } | undefined>()
  const history = useHistory()

  const { isEditingName, brandKitId } = state ?? {}

  const handleOpen = () => {
    history.replace({
      pathname,
      hash,
      search,
      state: { ...state, isEditingName: false, brandKitId: -1 },
    })
  }

  const handleClose = async (updatedName: string) => {
    if (!updatedName || updatedName === name) {
      return
    }

    mutate({ name: updatedName })
  }

  return (
    <EditableName
      name={name}
      onClose={handleClose}
      onOpen={handleOpen}
      forceOpen={isEditingName === true && brandKitId === brandKit.id}
      isDisabled={isDisabled}
      autoFocus
      {...props}
    />
  )
}
